import { Role } from '@/core/collections/modules/roles/role.interface';
import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { RoleService } from './role.service';

const service = new RoleService();

export interface RoleState {}

const RoleStore: Module<RoleState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {},
   actions: {
      async getRoles(context, tenantId: number) {
         return await service.getRoles(tenantId);
      },
      async addRoles(context, payload: { tenantId: number; roles: Array<Role> }) {
         return await service.postRolesBatch(payload.tenantId, payload.roles);
      },
      async deleteRoles(context, payload: { tenantId: number; roles: Array<Role> }) {
         return await service.deleteRolesBatch(payload.tenantId, payload.roles);
      },
   },
};

export default RoleStore;
